import {gql} from '@apollo/client'

export const GET_ONE_QUOTE = gql`
  query quotesById($id: String) {
    quotesById(id: $id) {
      id
      created
      updated
      CMSPlanId
      FFM
      NPN
      applicants
      dependents
      effectiveDate
      marketplaceId
      memberId
      members
      metalLevel
      paymentStatus
      planName
      policyTotalCost
      premium
      stateDocs
      taxCredit
      typeSale
      policyName
      nominalValue
      percentageValue
      status
      canceledDate
      completedDate

      type
      apizealCode
      commissionPayable

      city
      zipCode
      address1
      address2
      countyFips
      stateEU {
        name
        id
      }

      mailingAddress1
      mailingAddress2
      mailingCity
      mailingZipCode
      mailingCountyFips
      mailingStateeu {
        name
        id
      }

      archivedDate
      isImportant
      assignedTo {
        id
        firstName
        lastName
      }
      user {
        id
        firstName
        lastName
      }
      typePolicy {
        id
        typePolicy
      }
      carrier {
        id
        name
      }

      lead {
        id
        name
      }
      holderMember {
        id
        firstName
        lastName
        emailAddress
        phone
      }
      memberPolicySet {
        edges {
          node {
            id
            applicant
            firstName
            created
            updated
            rol
            middleName
            lastName
            secondLastName
            preferredLenguage
            dateBirth
            gender
            emailAddress
            phone
            maritalStatus
            countryBirth
            usesTobacco
            isPregnant
            hasMec
            weight
            height
            immigrationStatus
            immigrationStatusCode
            uscis
            passport
            ssn
            ssnIssuedDate
            greenCard
            greenCardIssuedDate
            greenCardExpirationDate
            workPermitCard
            workPermitIssuedDate
            workPermitExpirationDate
            driverLicense
            driverLicenseExpirationDate
            medicareNumber
            medicarePartAStartDate
            medicarePartBStartDate
            employerName1
            selfEmployed1
            employerPhone1
            positionOccupation1
            annualIncome1
            employerName2
            selfEmployed2
            employerPhone2
            positionOccupation2
            annualIncome2
            employerName3
            selfEmployed3
            employerPhone3
            positionOccupation3
            annualIncome3
            contact {
              id
            }
          }
        }
      }
      policyPayment {
        id
        recurrentPayment
        typeCard
        cardCompany
        cardNumber
        expirationMonth
        expirationDay
        cvvCsv
        firstPaymentDate
        bankAccount
        bankName
        ABARouting
        accountNumber
        preferredPayment
        billingAddress
        paymentHolder
        address1
        address2
        city
        zipCode
        stateEU {
          name
          id
        }
        policy {
          id
        }
      }
      policyExtraInfo {
        id
        primaryDoctorInfo
        medicinesNeeded
        infoExtra
        cancellationDate
        specialEnrollmentDate
        specialEnrollmentReason
      }
      policyAttachmentsSet {
        edges {
          node {
            id
            created
            name
            expirationDate
            attachments
            comments
            memberPolicy {
              id
              firstName
              lastName
            }
            documentTag {
              id
              tagName
            }
            user {
              id
              firstName
              lastName
            }
            policy {
              id
            }
          }
        }
      }
    }
  }
`

export const GET_ONE_QUOTE_BASE = gql`
  query quotesById($id: String) {
    quotesById(id: $id) {
      id
      created
      updated
      CMSPlanId
      FFM
      NPN
      applicants
      dependents
      effectiveDate
      marketplaceId
      memberId
      members
      metalLevel
      paymentStatus
      planName
      policyTotalCost
      premium
      stateDocs
      taxCredit
      typeSale
      policyName
      nominalValue
      percentageValue
      status
      canceledDate
      completedDate

      type
      apizealCode
      commissionPayable

      city
      zipCode
      address1
      address2
      countyFips
      stateEU {
        name
        id
      }

      mailingAddress1
      mailingAddress2
      mailingCity
      mailingZipCode
      mailingCountyFips
      mailingStateeu {
        name
        id
      }

      archivedDate
      isImportant
      assignedTo {
        id
        firstName
        lastName
      }
      user {
        id
        firstName
        lastName
      }
      typePolicy {
        id
        typePolicy
      }
      carrier {
        id
        name
      }

      lead {
        id
        name
      }
      holderMember {
        id
        firstName
        lastName
        emailAddress
        phone
      }
      memberPolicySet {
        edges {
          node {
            id
            applicant
            firstName
            created
            updated
            rol
            middleName
            lastName
            secondLastName
            preferredLenguage
            dateBirth
            gender
            emailAddress
            phone
            maritalStatus
            countryBirth
            usesTobacco
            isPregnant
            hasMec
            weight
            height
            immigrationStatus
            immigrationStatusCode
            uscis
            passport
            ssn
            ssnIssuedDate
            greenCard
            greenCardIssuedDate
            greenCardExpirationDate
            workPermitCard
            workPermitIssuedDate
            workPermitExpirationDate
            driverLicense
            driverLicenseExpirationDate
            medicareNumber
            medicarePartAStartDate
            medicarePartBStartDate
            employerName1
            selfEmployed1
            employerPhone1
            positionOccupation1
            annualIncome1
            employerName2
            selfEmployed2
            employerPhone2
            positionOccupation2
            annualIncome2
            employerName3
            selfEmployed3
            employerPhone3
            positionOccupation3
            annualIncome3
            contact {
              id
            }
          }
        }
      }
      policyPayment {
        id
        recurrentPayment
        typeCard
        cardCompany
        cardNumber
        expirationMonth
        expirationDay
        cvvCsv
        firstPaymentDate
        bankAccount
        bankName
        ABARouting
        accountNumber
        preferredPayment
        billingAddress
        paymentHolder
        address1
        address2
        city
        zipCode
        stateEU {
          name
          id
        }
        policy {
          id
        }
      }
      policyExtraInfo {
        id
        primaryDoctorInfo
        medicinesNeeded
        infoExtra
        cancellationDate
        specialEnrollmentDate
        specialEnrollmentReason
      }
    }
  }
`

export const GET_ONE_QUOTE_ATTACHMENTS = gql`
  query quotesById($id: String) {
    quotesById(id: $id) {
      id
      policyAttachmentsSet {
        edges {
          node {
            id
            created
            name
            expirationDate
            attachments
            comments
            memberPolicy {
              id
              firstName
              lastName
            }
            documentTag {
              id
              tagName
            }
            user {
              id
              firstName
              lastName
            }
            policy {
              id
            }
          }
        }
      }
    }
  }
`
